import { ICollectionSlot } from '@lootboy/lib/slices/cardCollections/types';
import { findLastIndex } from '@lootboy/lib/utils/arrays';
import { isEmptyObject } from '@lootboy/lib/utils/records';

import cardGridConstants from '../CollectionView.consts.module.scss';

export const getGridPlacement = (
  index: number,
  numberOfColumns: number,
): { column: number; row: number } => ({
  column: (index % numberOfColumns) + 1,
  row: Math.floor(index / numberOfColumns) + 1,
});

export const getSpecialGroupBoundaries = (
  specialGroups: Array<{ id: string; image: string }>,
  slots: Array<ICollectionSlot | Record<never, never>>,
  gridColumns: number,
): Array<{
  start: { column: number; row: number };
  end: { column: number; row: number };
  specialGroup: { id: string; image: string };
}> =>
  specialGroups.map((specialGroup) => ({
    start: getGridPlacement(
      slots.findIndex(
        (slot) => !isEmptyObject(slot) && slot.specialGroup === specialGroup.id,
      ),
      gridColumns,
    ),
    end: getGridPlacement(
      findLastIndex(
        slots,
        (slot) => !isEmptyObject(slot) && slot.specialGroup === specialGroup.id,
      ),
      gridColumns,
    ),
    specialGroup,
  }));

type TGetPositionArgs = {
  index: number;
  numberOfSegments: number;
  parentSize: number;
  isMobile: boolean;
};

export const getGridPosition = ({
  index,
  numberOfSegments,
  parentSize,
  isMobile,
}: TGetPositionArgs): number => {
  const gapSize = Number(
    isMobile
      ? cardGridConstants.gridGapSizeMobile
      : cardGridConstants.gridGapSize,
  );
  return (
    (index + 1) *
      ((parentSize - (numberOfSegments - 1) * gapSize) / numberOfSegments) +
    gapSize * index +
    gapSize / 2
  );
};

export const getBorderPosition = ({
  index,
  numberOfSegments,
  parentSize,
  isMobile,
}: TGetPositionArgs): `${number}px` => {
  return `${
    getGridPosition({
      index,
      numberOfSegments,
      parentSize,
      isMobile,
    }) -
    Number(cardGridConstants.specialGroupBoderWidth) -
    Number(cardGridConstants.specialGroupBoderWidth) / 2
  }px`;
};
